module.exports = __webpack_public_path__ + "media/icons/award-176ff949.png";